export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            投稿合作
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            与蛙漫一起成长
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed max-w-[550px] mx-auto">
            无论你是漫画创作者、翻译团队，还是商务合作伙伴，
            蛙漫漫画都期待与你携手，共同为读者带来更多精彩的漫画内容。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
            <div className="p-5 rounded-2xl bg-background-50 border border-background-200/60">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3 mx-auto">
                <i className="ri-pencil-ruler-2-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">作者投稿</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                原创漫画作者入驻通道，平台推广支持
              </p>
              <a
                href="mailto:author@waman.com"
                className="inline-block mt-3 text-xs font-medium text-accent-600 hover:text-accent-700 cursor-pointer"
              >
                author@waman.com
              </a>
            </div>

            <div className="p-5 rounded-2xl bg-background-50 border border-background-200/60">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3 mx-auto">
                <i className="ri-team-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                广告投放、品牌联动、IP授权合作洽谈
              </p>
              <a
                href="mailto:biz@waman.com"
                className="inline-block mt-3 text-xs font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
              >
                biz@waman.com
              </a>
            </div>

            <div className="p-5 rounded-2xl bg-background-50 border border-background-200/60">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-3 mx-auto">
                <i className="ri-chat-smile-2-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                功能建议、问题反馈、内容举报通道
              </p>
              <a
                href="mailto:feedback@waman.com"
                className="inline-block mt-3 text-xs font-medium text-secondary-600 hover:text-secondary-700 cursor-pointer"
              >
                feedback@waman.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}